/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './order-item-page.component.html';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {OrderModel} from './order-api.service';

@Component({
  standalone: false,
  selector: 'adn-order-item-page',
  template
})
export class OrderItemPageComponent {
  @Input() state: SignalAdminResourcePageState<OrderModel>;
}
